import ApplicationFeeDetailsModal from '@views/onboarding/@elements/ApplicationFeeDetailsModal'
import ApplicationFeeInfoModal from '@views/onboarding/@elements/ApplicationFeeInfoModal'
import ApplicationFeeSuccessModal from '@views/onboarding/@elements/ApplicationFeeSuccessModal'
import { useMerchantAccounts, useMerchantQry } from 'mmfintech-backend-api'
import type { AccountBalanceResponse } from 'mmfintech-backend-api/types'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'

export const usePayApplicationFee = () => {
  const { modalHide, modalShow } = useContext(GlobalContext)

  const { merchant } = useMerchantQry()
  const { accountSetupFee } = merchant || {}

  const { accounts } = useMerchantAccounts()

  const payApplicationFee = () => {
    modalHide()

    const euroAccountWithFunds = accounts?.find(
      (account: AccountBalanceResponse) =>
        account.currencyCode === 'EUR' && account.availableBalance >= accountSetupFee?.amount
    )

    if (euroAccountWithFunds) {
      modalShow({
        header: tr('MERCHANTS.TRANSACTION.TYPE.ACCOUNT_SETUP_FEE', 'Application fee'),
        content: (
          <ApplicationFeeInfoModal
            accountId={euroAccountWithFunds?.id}
            onSuccess={() => {
              modalShow({
                content: <ApplicationFeeSuccessModal />,
                options: {
                  size: 'auto',
                  transparent: true,
                  closeOnClickOutside: false,
                  closeOnEscape: false
                }
              })
            }}
          />
        ),
        options: {
          closeOnClickOutside: false
        }
      })
    } else {
      modalShow({
        header: tr('MERCHANTS.TRANSACTION.TYPE.ACCOUNT_SETUP_FEE', 'Application fee'),
        content: <ApplicationFeeDetailsModal />,
        options: {
          closeOnClickOutside: true
        }
      })
    }
  }

  return {
    payApplicationFee
  }
}
